import React, { useState } from "react";
var moment = require("moment");

const Convos = props => {
  const { convos } = props;

  return (
    <>
      {convos.map(e => {
        return (
          <>
            <b>{e.username}:</b>
            <span style={{ color: "white" }}>{` ${e.message}  `}</span>
            <i>
              -->{" "}
              {moment(e.timestamp)
                .startOf("hour")
                .fromNow()}
            </i>
            <br />
          </>
        );
      })}
    </>
  );
};
export default Convos;
